import React from "react";
import { Column, Columns, Input, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";
import PartRow from "./PartRow";


export default function PartListModal({partOrder, show, setShow}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            closeOnBlur
            active={show}
            onClose={() => setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Parts for order {partOrder ? partOrder.id : ""}</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <label className="label">Customer Vehicle</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={partOrder ? partOrder.customer_vehicle : ""}
                            />
                        </Column>
                        <Column>
                            <label className="label">Customer Order Number</label>
                            <Input
                                type={"text"}
                                disabled={true}
                                value={partOrder ? partOrder.order_number : ""}
                            />
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table isFullwidth>
                                <thead>
                                    <tr>
                                        <th>Part Number</th>
                                        <th>Part Name</th>
                                        <th>Part Customer Charge</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {partOrder && partOrder.parts && partOrder.parts.map(part => (
                                        <PartRow
                                            part={part}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );
}